import { gql } from '@apollo/client';
import UPDATE_STUDENT_SETTING_FRAGMENT from '../../fragments/update-student-setting-fragment';

const UPDATE_KEY_STUDENT_STOP_AND_REVIEW_SETTING = gql`
  mutation updateKeyStudentSettingStopAndReview(
    $data: [UpdateKeyStudentSettingStopAndReviewInput!]!
  ) {
    updateKeyStudentSettingStopAndReview(data: $data) {
      ...UpdateStudentSettingFragment
    }
  }
  ${UPDATE_STUDENT_SETTING_FRAGMENT}
`;

export default UPDATE_KEY_STUDENT_STOP_AND_REVIEW_SETTING;
